import React from 'react'
import { useTranslation } from 'react-i18next'
import { TextField, Box, MenuItem } from '@mui/material'

import { BonusType } from '@/enums'
import keys from '@/utils/keys'
import { WalletFilters } from '@/state/wallets/models'

type Props = {
  filters: WalletFilters
  handleChangeSearch: (
    newFilter: Partial<WalletFilters>,
    debounce?: boolean,
  ) => void
}

export const WalletTypeBonusFilter = ({
  filters,
  handleChangeSearch,
}: Props) => {
  const { t } = useTranslation()

  const INCLUDED_BONUS = ['CASINO_STANDARD', 'FREE_SPINS']

  const bonusTypes = [
    ...keys(BonusType)
      .filter(
        (item) =>
          typeof BonusType[item] !== 'number' && INCLUDED_BONUS.includes(item),
      )
      .map((x) => ({
        index: BonusType[x],
        label: x,
      })),
  ].sort((a, b) => a.label.localeCompare(b.label))

  // const bonusTypes = [
  //   ...keys(BonusType)
  //     .filter(
  //       (item) =>
  //         typeof BonusType[item] !== 'number' &&
  //         ((env === 'prod' &&
  //           (item === 'CASINO_STANDARD' ||
  //             item === 'FREE_SPINS' ||
  //             // item === 'FREE_PLAY' ||
  //             item === 'BETSOFT_CASINO')) ||
  //           (env === 'stg' &&
  //             (item === 'CASINO_STANDARD' ||
  //               item === 'FREE_SPINS' ||
  //               // item === 'FREE_PLAY' ||
  //               item === 'BETSOFT_CASINO'))),
  //     )
  //     .map((x) => {
  //       return {
  //         index: BonusType[x],
  //         label: x,
  //       }
  //     }),
  // ].sort((a, b) => a.label.localeCompare(b.label))

  const bonusTypesOptions = bonusTypes.map((type) => {
    return (
      <MenuItem key={type.index} value={type.index}>
        {t(`bonusTypes.${type.label}`)}
      </MenuItem>
    )
  })

  return (
    <TextField
      fullWidth
      name="bonusType"
      margin="dense"
      variant="outlined"
      label={t('labels.bonusType')}
      value={filters?.walletType || ''}
      onChange={(e: React.ChangeEvent<{ value: string }>) => {
        handleChangeSearch({ walletType: e.target.value })
      }}
      select
    >
      <MenuItem value="">
        <Box fontStyle="italic">{t('all')}</Box>
      </MenuItem>
      {bonusTypesOptions}
    </TextField>
  )
}
